import { createSlice } from "@reduxjs/toolkit";

// Hardcoded backend page size
const DEFAULT_PAGE_SIZE = 1;

const initialState = {
  category: null,
  inventory_id: null,
  status: null,
  search: null,
  cursor: 0,          // Tracks next cursor for infinite scroll
  pagination: DEFAULT_PAGE_SIZE, // Always 1
};

const productListFilterSlice = createSlice({
  name: "productListFilter",
  initialState,
  reducers: {
    /** Set or update filters. Reset cursor if main filter changes */
    setProductListFilter: (state, action) => {
      const { category, inventory_id, status, search } = action.payload;
      let resetCursor = false;

      if (category !== undefined && state.category !== category) {
        state.category = category;
        resetCursor = true;
      }
      if (inventory_id !== undefined && state.inventory_id !== inventory_id) {
        state.inventory_id = inventory_id;
        resetCursor = true;
      }
      if (status !== undefined && state.status !== status) {
        state.status = status;
        resetCursor = true;
      }
      if (search !== undefined && state.search !== search) {
        state.search = search;
        resetCursor = true;
      }

      if (resetCursor) state.cursor = 0;
    },

    /** Only update cursor (infinite scroll) */
    setProductListCursor: (state, action) => {
      state.cursor = action.payload;
    },

    /** Reset all filters */
    clearProductListFilters: () => initialState,
  },
});

export const {
  setProductListFilter,
  setProductListCursor,
  clearProductListFilters,
} = productListFilterSlice.actions;

export const selectProductListState = (state) => state.productListFilter;

export default productListFilterSlice.reducer;
